import { useQuery } from '@tanstack/react-query';
import { getMyAccessLock } from '../services/api/implementation/impl';

/**
 * Whether super admin has limited or locked this account for unpaid bills.
 * The server enforces the lock on every API call; this only drives the notice.
 * A failed lookup reads as unlocked so a network blip never blanks the app.
 */
export function useAccessLock() {
  const query = useQuery({
    queryKey: ['myAccessLock'],
    queryFn: getMyAccessLock,
    staleTime: 60 * 1000,
    refetchInterval: 5 * 60 * 1000,
    refetchOnWindowFocus: true,
    retry: false
  });

  const data = query.data ?? null;
  const status = data?.status || 'active';

  return {
    status,
    isLocked: status === 'locked',
    isLimited: status === 'limited',
    groups: Array.isArray(data?.groups) ? data.groups : [],
    message: data?.message || null
  };
}
